const PropTypes = require('prop-types');
const React = require('react');
const APIRequest = require('components/api_request.js');
const accounting = require('accounting');
const moment = require('moment');

const BumpSetup = require('./bump_setup.jsx');
const BumpChange = require('./bump_change.jsx');
const BumpBidSlider = require('./bump_bid_slider.jsx');

class ProductPageBump extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      bid: this.props.bid,
      selectedBid: this.props.bid,
      error: false,
      bidChange: false,
      deleted: false,
      showMobileSlider: false,
    };
  }

  get bidSlider() {
    return (
      <BumpBidSlider
        bidTiers={this.props.bidTiers}
        tierIncrement={this.props.tierIncrement}
        bid={this.state.selectedBid}
        setBid={this.state.bid}
        updateBid={(newBid) => this.updateBid(newBid)}
        bidChanged={(newBid) => this.setState({ selectedBid: newBid })}
        error={this.state.error}
        bidChange={this.state.bidChange}
        changeDismiss={() => this.setState({ bidChange: false })}
        deleted={this.state.deleted}
      />
    );
  }

  toggleSlider() {
    this.setState({ showMobileSlider: !this.state.showMobileSlider });
  }

  get showStats() {
    return this.state.bid ||
      this.props.salesCount ||
      accounting.unformat(this.props.salesSpent) ||
      accounting.unformat(this.props.salesRevenue);
  }

  get content() {
    if (this.showStats) {
      return (
        <BumpChange
          bidSlider={this.bidSlider}
          impressions={this.props.impressions || 0}
          salesCount={this.props.salesCount || 0}
          salesSpent={this.props.salesSpent || '0'}
          salesRevenue={this.props.salesRevenue || '0'}
          averagePosition={this.props.averagePosition || 0}
          hasComparisonShoppingPage={this.props.hasComparisonShoppingPage}
          showMobileSlider={this.state.showMobileSlider}
          sliderToggle={() => this.toggleSlider()}
          currentBid={this.state.selectedBid}
        />
      );
    }

    return (
      <BumpSetup
        bidSlider={this.bidSlider}
        exampleBumpPercent={this.props.exampleBumpPercent}
        listingPrice={this.props.listingPrice}
        exampleSpend={this.props.exampleSpend}
        isNewCondition={this.props.isNewCondition}
        showMobileSlider={this.state.showMobileSlider}
        sliderToggle={() => this.toggleSlider()}
      />
    );
  }

  get adminBidMessage() {
    const { adminBid } = this.props;
    if (!(adminBid && adminBid.bid)) { return null; }

    return (
      <h1 className="product-bump__admin-bump-header">
        {I18n.t('js.bump.adminBump', {
          percentage: adminBid.bid * 100,
          expirationDate: moment(adminBid.expires_at).format('MMMM D'),
        })}
      </h1>
    );
  }

  setBid(newBid) {
    APIRequest.post('/bump/bids/', {
      bump_bids: {
        product_id: this.props.productId,
        bid: newBid,
      },
    })
      .then(() => {
        this.setState({ bid: newBid, selectedBid: newBid, error: false, bidChange: true, deleted: false });
      })
      .fail(() => this.setState({ error: true, selectedBid: this.state.bid }));
  }

  deleteBid() {
    APIRequest.destroy(`/bump/bids/${this.props.productId}`)
      .then(() => {
        this.setState({ bid: null, selectedBid: null, error: false, deleted: true, bidChange: true });
      })
      .fail(() => this.setState({ error: true, selectedBid: this.state.bid }));
  }

  updateBid(newBid) {
    this.setState({ selected: newBid });
    if (newBid === 0.0) {
      this.deleteBid();
    } else {
      this.setBid(newBid);
    }
  }

  render() {
    return (
      <div>
        {this.adminBidMessage}
        {this.content}
      </div>
    );
  }
}

ProductPageBump.propTypes = {
  productId: PropTypes.number.isRequired,
  bidTiers: PropTypes.array.isRequired,
  tierIncrement: PropTypes.number.isRequired,
  bid: PropTypes.string,
  adminBid: PropTypes.object,
  impressions: PropTypes.number,
  salesCount: PropTypes.number,
  salesSpent: PropTypes.string,
  salesRevenue: PropTypes.string,
  averagePosition: PropTypes.number,
  exampleBumpPercent: PropTypes.string,
  listingPrice: PropTypes.string,
  exampleSpend: PropTypes.string,
  hasComparisonShoppingPage: PropTypes.bool,
  isNewCondition: PropTypes.bool,
};

module.exports = ProductPageBump;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/bump_for_new/product_page_bump.jsx